import { PublicEvents } from "../types/Events.types";
import { processEvent } from "../services/processEvent.service";
/**
 * Analytics Api: formFieldEvent.
 * @param {object} FormFieldEventParams Object with the form field event details.
 * @param {string} FormFieldEventParams.formName Title of the page that the form field is located on.
 * @param {string} [FormFieldEventParams.formStep] A data point listed within the event target.
 * @param {object} [customPayload] An optional payload that may be provided to send additional data with the event.
 *
 * @example
 * import { formFieldEvent } from "@octagon/public-analytics";
 *
 * // With NO additional payload data
 * formFieldEvent({
 *   formName: "Chase Home",
 *   formStep: e.target["data-chase-track"]
 * });
 *
 * // With additional payload data
 * formFieldEvent(
 *   {
 *     formName: "Chase Home",
 *     formStep: e.target["data-chase-track"]
 *   },
 *   { devSpecifiedData: "1625254612928" }
 * );
 *
 * @category Events
 */
export function formFieldEvent(params, customPayload) {
    if (customPayload === void 0) { customPayload = {}; }
    processEvent(PublicEvents.FORM_FIELD, params, customPayload);
}
